import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/domains/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/invoice-history')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Invoice History',
    tabKey: 'client/invoice-history',
  },
  pendingComponent: Loading,
});
